module.exports = __webpack_public_path__ + "static/media/cartao_visita.ce269868.jpg";